import React, { lazy } from 'react';
import { RouteProps } from 'react-router-dom';
import { loginPages, dashboardPagesMenu, masterPagesMenu, superAdminMenu } from '../menu';
import Login from '../pages/presentation/auth/Login';
import ManagementLeaveReport from '../pages/ReportsPage/ManagementLeaveReport';
import DesignationWiseLeaveReport from '../pages/ReportsPage/DesignationWiseLeaveReport';
import MonthlyAttendanceSummaryReport from '../pages/ReportsPage/MonthlyAttendanceSummaryReport';
import EmployeeLeaveReport from '../pages/ReportsPage/EmployeeLeaveReport';
import MonthlyCheckoutReport from '../pages/ReportsPage/MonthlyCheckoutReport';
import CompOffReportPage from '../pages/ReportsPage/CompOffReportPage';
import OnDutyReportPage from '../pages/ReportsPage/OnDutyReportPage';
import LeaveRestrictionPage from '../pages/LeaveRestrictionPage/LeaveRestrictionPage';
import FestivalAdvancesReportPage from '../pages/ReportsPage/FestivalAdvancesReportPage';
import MedicalAllowanceReportPage from '../pages/ReportsPage/MedicalAllowanceReportPage';


const LANDING = {
	DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage')),
};
const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};
const MASTER = {
	BRANCH: lazy(() => import('../pages/branch/branchPage')),
	SECTION: lazy(() => import('../pages/section/sectionPage')),
	EMPLOYEE: lazy(() => import('../pages/employee/employeePage')),
	TRANSFER: lazy(() => import('../pages/UpdateEmployee/TransferEmployeeComponent')),
	WEB_CHECKIN: lazy(() => import('../pages/webCheckIn/webCheckInComponent')),
	VISITOR_PASS: lazy(() => import('../pages/VisitorPass/VisitorPassComponent')),
	ORGANISATION: lazy(() => import('../pages/orgnisation/organisationPage')),
	REPORTS: lazy(() => import('../pages/ReportsPage/ReportsPage')),
	LEAVE_REPORT: lazy(() => import('../pages/ReportsPage/LeaveReportPage')),
	SECTION_WISE_ATTENDANCE: lazy(() => import('../pages/ReportsPage/SectionWiseAttendanceReport')),
	CHECK_IN_LOCKED: lazy(() => import('../pages/CheckInLocked/CheckInLockedReport')),
	LEAVE_REASON_MASTER: lazy(() => import('../pages/LeaveReasonMaster/LeaveReasonsAdd')),
	LEAVE_RESTRICTION: lazy(() => import('../pages/LeaveRestrictionPage/LeaveRestrictionPage')),
	APPLY_LEAVE_ADMIN: lazy(() => import('../pages/ApplyLeaveAdmin/ApplyLeaveAdminPage')),
	LEAVE_ADJUSTMENT: lazy(() => import('../pages/LeaveAdjustment/LeaveAdjustmentPage')),
	REFRESHMENTS: lazy(() => import('../pages/Allowances/RefreshmentsPage')),
	NEWSPAPER: lazy(() => import('../pages/Allowances/NewspaperPage')),
};
const presentation: RouteProps[] = [
	/**
	 * Landing
	 */
	{
		path: dashboardPagesMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
	},

	/** ************************************************** */

	/** ********************* LOGIN START ***************************** */
	{
		path: loginPages.page404.path,
		element: <AUTH.PAGE_404 />,
	},
	{
		path: loginPages.login.path,
		element: <Login />,
	},
	// {
	// 	path: loginPages.signUp.path,
	// 	element: <Login isSignUp />,
	// },
	/** ********************* LOGIN END ***************************** */

	/**
	 * App > CRM
	 */
	{
		path: masterPagesMenu.master.subMenu.branchList.path,
		element: <MASTER.BRANCH />,
	},
	{
		path: masterPagesMenu.master.subMenu.sectionList.path,
		element: <MASTER.SECTION />,
	},
	{
		path: masterPagesMenu.master.subMenu.employeeList.path,
		element: <MASTER.EMPLOYEE />,
	},
	{
		path: masterPagesMenu.master.subMenu.transferList.path,
		element: <MASTER.TRANSFER />,
	},
	{
		path: masterPagesMenu.master.subMenu.webCheckIn.path,
		element: <MASTER.WEB_CHECKIN />,
	},
	{
		path: masterPagesMenu.master.subMenu.visitorPass.path,
		element: <MASTER.VISITOR_PASS />,
	},
	{
		path: masterPagesMenu.master.subMenu.leaveRestriction.path,
		element: <MASTER.LEAVE_RESTRICTION />,
	},
	{
		path: masterPagesMenu.master.subMenu.applyLeaveAdmin.path,
		element: <MASTER.APPLY_LEAVE_ADMIN />,
	},
	{
		path: masterPagesMenu.master.subMenu.leaveAdjustment.path,
		element: <MASTER.LEAVE_ADJUSTMENT />,
	},
	{
		path: masterPagesMenu.master.subMenu.leaveReasonMaster.path,
		element: <MASTER.LEAVE_REASON_MASTER />,
	},
	{
		path: superAdminMenu.master.subMenu.organisationList.path,
		element: <MASTER.ORGANISATION />,
	},
	{
		path: 'reports/xreports-generate',
		element: <MASTER.REPORTS />,
	},
	{
		path: 'reports/attendance-report',
		element: <MASTER.REPORTS />,
	},
	{
		path: 'reports/leave-report',
		element: <React.Suspense fallback={<div>Loading...</div>}><MASTER.LEAVE_REPORT /></React.Suspense>,
	},
	{
		path: 'reports/section-wise-attendance-report',
		element: <MASTER.SECTION_WISE_ATTENDANCE />,
	},
	{
		path: 'reports/check-in-locked',
		element: <MASTER.CHECK_IN_LOCKED />,
	},
	{
		path: 'allowances/refreshments',
		element: <MASTER.REFRESHMENTS />,
	},
	{
		path: 'allowances/newspaper',
		element: <MASTER.NEWSPAPER />,
	},


	/**
	 * END - App
	 */

	/** ************************************************** */
];

const leaveReportRoutes: RouteProps[] = [
	{
		path: 'reports/management-leave',
		element: <ManagementLeaveReport />,
	},
	{
		path: 'reports/designation-leave',
		element: <DesignationWiseLeaveReport />,
	},
	{
		path: 'reports/monthly-attendance-summary',
		element: <MonthlyAttendanceSummaryReport />,
	},
	{
		path: 'reports/employee-leave',
		element: <EmployeeLeaveReport />,
	},
	{
		path: 'reports/monthly-checkout',
		element: <MonthlyCheckoutReport />,
	},
    {
        path: 'reports/compoff',
        element: <CompOffReportPage />,
    },
    {
        path: 'reports/on-duty',
        element: <OnDutyReportPage />,
    },
    {
        path: 'reports/festival-advances',
        element: <FestivalAdvancesReportPage />,
    },
    {
        path: 'reports/medical-allowance',
        element: <MedicalAllowanceReportPage />,
    },
];

const contentRoutes: RouteProps[] = [...presentation, ...leaveReportRoutes];

export default contentRoutes;
